export enum RessouretypeTypes {
    WORKER = 'worker',
    MACHINE = 'machine'
}
